import React from "react";

import {
    Box,
    Typography
} from "@mui/material";

import {
    motion
} from "framer-motion";


const BioLinkProfile = ({
    user,
    dashboardBanner
}) => {


return (

<motion.div

initial={{
opacity:0,
y:20
}}

animate={{
opacity:1,
y:0
}}

transition={{
duration:.5
}}

>


<Box
sx={{

height:{
xs:180,
sm:250,
md:320
},

borderRadius:5,

overflow:"hidden",

position:"relative",

boxShadow:
"0 20px 45px rgba(0,0,0,.12)"

}}

>


<img

src={dashboardBanner}

alt="dashboard"

style={{

width:"100%",

height:"100%",

objectFit:"cover"

}}

/>





<Box

sx={{

position:"absolute",

inset:0,

background:
"linear-gradient(90deg,rgba(128,0,0,.75),rgba(0,0,0,.25))",

display:"flex",

alignItems:"center",

padding:{

xs:3,

md:6

}

}}

>





<Box>



<Typography

sx={{

color:"#fff",

fontWeight:900,

fontSize:{

xs:24,

md:42

}

}}

>

Welcome Back, {user?.username}

</Typography>






<Typography

sx={{

color:"#fff",

opacity:.9,

fontSize:{

xs:13,

md:17

},

mt:1

}}

>

Manage your tasks academic progress, attendance and school activities.

</Typography>





</Box>



</Box>





</Box>



</motion.div>


);


};


export default BioLinkProfile;